// extracted by mini-css-extract-plugin
export default {"root":"k3JXr8","enter":"guXSp7","enterActive":"TqQL29","exitActive":"Ip_cox","fullScreen":"KDFcpq","shadowOverlay":"_5r6CpM","image":"xD8czR"};